import { render, staticRenderFns } from "./OtsCustomDialog.vue?vue&type=template&id=69b2ef2f&scoped=true&"
import script from "./OtsCustomDialog.vue?vue&type=script&lang=js&"
export * from "./OtsCustomDialog.vue?vue&type=script&lang=js&"
import style0 from "./OtsCustomDialog.vue?vue&type=style&index=0&id=69b2ef2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b2ef2f",
  null
  
)

export default component.exports